import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  openModal () {
    this.modalTarget.show();
  }

  closeModal (event) {
    // Only failed Turbo submissions change the default close-and-reset behavior.
    if (event.type === "turbo:submit-end" && !event.detail.success) return;

    this.modalTarget.hide();
    this.clearForm();
  }

  clearForm () {
    this.form = this.element.querySelector("form");
    if (this.form) {
      this.form.reset();
    }
  }
}
